function IOSInfo() {
    return <><p>支持iOS 13.0及以上版本</p>
        <p>iOS 13.0以上版本需要手动信任企业证书才能正常使用</p>
        <p>请在设置&gt;通用&gt;设备管理，</p>
        <p>选择并信任相应的企业级证书</p></>
}

export default IOSInfo